module.exports = __webpack_public_path__ + "static/media/Aitchison College.d426bc43.jpeg";